import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-forgot-password-success',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './forgot-password-success.component.html',
  styleUrl: './forgot-password-success.component.scss',
})
export class ForgotPasswordSuccessComponent {
  constructor(private router: Router, private authService: AuthService) {}

  public onClickCancel() {
    this.router.navigate(['/'], { queryParams: { redirectUrl: this.authService.redirectUrl } });
  }
}
